import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'
import BaseDropdown, { ComboBoxOption, DropdownProps } from '../../../components/Dropdown/BaseDropdown'
import { FileMatchType, FileMatchTypeLabelMap, FileSuggestionMatchDto } from '../../FileMessage/FileMessageForm'
import { DataPromise } from '../../../context/AxiosContext'
import { SelectableOptionMenuItemType } from '@fluentui/react'
import FileContext, { FileListItemDto, FileStatus, mapFileOptions, sortFileOptions } from '../../../context/FileContext'
import useEntity from '../../../hooks/useEntity'
import { SortSetting } from '../../../config/settingConfig'

type Props = Omit<DropdownProps<FileListItemDto>, 'options'> & {
    suggestions: DataPromise<FileSuggestionMatchDto[]>
}

export default function FileSuggestionDropdown(props: Props): ReactElement {
    const { files } = useContext(FileContext)
    const [{ data: fileSort }] = useEntity<SortSetting>(() => ({ url: '/setting/file-sort' }), false)
    const [options, setOptions] = useState<ComboBoxOption<FileListItemDto>[]>([])

    useEffect(() => {
        const data = files.data.filter(file => file.status === FileStatus.Open) || []

        setOptions([
            ...[FileMatchType.Reference, FileMatchType.Party, FileMatchType.TimeSuggestion, FileMatchType.Conversation]
                .map(type => [
                    { key: `divider-${type}`, text: '', itemType: SelectableOptionMenuItemType.Divider },
                    {
                        key: `header-${type}`,
                        text: FileMatchTypeLabelMap.get(type),
                        itemType: SelectableOptionMenuItemType.Header,
                    },
                    ...(props.suggestions.data || [])
                        .filter(suggestion => suggestion.matchType === type)
                        .flatMap(suggestion => data.filter(file => file.id === suggestion.id))
                        .map(mapFileOptions<FileListItemDto>(fileSort, 'reference'))
                        .sort(sortFileOptions<FileListItemDto>(fileSort)),
                ])
                .filter(options => options.length > 2)
                .flatMap(files => files),
            { key: 'divider-other', text: '', itemType: SelectableOptionMenuItemType.Divider },
            { key: 'header-other', text: 'Overig', itemType: SelectableOptionMenuItemType.Header },
            ...data
                .filter(file => !(props.suggestions.data || []).map(suggestion => suggestion.id).includes(file.id))
                .map(mapFileOptions<FileListItemDto>(fileSort, 'reference'))
                .sort(sortFileOptions<FileListItemDto>(fileSort)),
        ])
    }, [fileSort, files.data, props.suggestions.data])

    return <BaseDropdown<FileListItemDto> {...props} options={options} />
}
